import { LoginComponent } from './componentes/login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AutenticacaoService } from './servicos/autenticacao.service';
import { AceiteTermosComponent } from './aceite-termos/aceite-termos.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'aceite-termos', component: AceiteTermosComponent, canActivate:[AutenticacaoService] },
  { path: 'autenticador', redirectTo: 'inicial' }, // validação por SMS desativada (ValidadorZapComponent)
  { path: '', loadChildren: () => import('./area-logada/area-logada.module').then(m => m.AreaLogadaModule) },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
